export default __webpack_public_path__ + "static/media/footerBackground.6bdf4b95.svg";